import van from "vanjs-core";
import { modal } from "..";
import { assets } from "../app-env/common";
import { dateString, t } from "../locale";
import { materialSymbol } from "../van/material-symbol";
import { Html } from "../view/html";

/**
 * @typedef {object} DeviceCardConfig
 * @property {string} deviceName
 * @property {DeviceType} deviceType
 * @property {string} productName
 * @property {string[]} warnings
 * @property {HTMLParagraphElement[]} lines
 * @property {HTMLAnchorElement[]} buttons
 
 * @param {DeviceCardConfig} cfg 
 */
function deviceCard(cfg) {
	cfg.buttons.forEach((a) => {
		a.classList.add("card-footer-item");
	});
	return van.tags.div(
		{ class: "card" },
		van.tags.div(
			{ class: `card-header p-2 ${cfg.deviceType}` },
			van.tags.div(
				{ class: "media" },
				van.tags.figure(
					{ class: "media-left" },
					van.tags.figure(
						{ class: "image is-48x48" },
						van.tags.img({ src: assets[`${cfg.deviceType}.svg`] }),
					),
				),
				van.tags.div(
					{ class: "media-content" },
					van.tags.h1({ class: "title is-4" }, cfg.deviceName),
					van.tags.h2({ class: "subtitle is-6" }, cfg.productName),
				),
				van.tags.div(
					{ class: "media-right" },
					materialSymbol({
						flashing: true,
						hidden: cfg.warnings.length < 1,
						id: "error",
						onclick: () =>
							openWarningsModal(cfg.deviceName, cfg.warnings),
						size: 1,
					}),
				),
			),
		),
		van.tags.div({ class: "card-content" }, ...cfg.lines),
		van.tags.div(
			{ class: `card-footer ${cfg.deviceType}` },
			...cfg.buttons,
		),
	);
}

/**
 * @param {Subscription} sub
 * @returns {[string,string]} localised label, formatted date
 */
function formatSubscriptionStatus(sub) {
	const now = new Date();
	const expiresAt = new Date(sub.ExpiresAt);
	const expiresAtFormatted = dateString(expiresAt);

	if (sub.PriceIds.Next) {
		return [
			`- ${t.device.card.subscriptionStatusRenews}`,
			expiresAtFormatted,
		];
	}

	if (expiresAt < now) {
		return [
			`- ${t.device.card.subscriptionStatusEnded}`,
			expiresAtFormatted,
		];
	}

	return [`- ${t.device.card.subscriptionStatusEnds}`, expiresAtFormatted];
}

/**
 *
 * @param {string} deviceName
 * @param {string[]} warnings
 */
function openWarningsModal(deviceName, warnings) {
	modal.open({
		header: deviceName,
		body: [Html.unorderedList(...warnings).element],
		footer: [],
	});
}

export { deviceCard, formatSubscriptionStatus };
